export const blueprint = [
  {
    id: "standards",
    icon: "Flag",
    title: "Standards",
    summary: "The non-negotiables that define how we operate.",
    points: [
      "We are on time, prepared, and ready to compete.",
      "Effort and attitude are choices we make every day.",
      "We do the little things right, especially when no one is watching.",
      "We hold ourselves and each other accountable to the standard.",
    ],
  },
  {
    id: "culture",
    icon: "Users",
    title: "Culture",
    summary: "The shared identity and values that bind the program.",
    points: [
      "Team before self — the name on the front matters most.",
      "Compete in everything, celebrate each other's success.",
      "Embrace hard work as a privilege, not a punishment.",
      "Leave the program better than you found it.",
    ],
  },
  {
    id: "leadership-expectations",
    icon: "Star",
    title: "Leadership Expectations",
    summary: "What it means to lead within our program.",
    points: [
      "Lead by example before you lead by voice.",
      "Set the standard in conditioning, film, and practice.",
      "Hold teammates accountable with respect.",
      "Serve the team — leadership is responsibility, not status.",
    ],
  },
  {
    id: "practice-habits",
    icon: "Repeat",
    title: "Practice Habits",
    summary: "How we train to build winning habits.",
    points: [
      "Sprint to every line, finish every rep.",
      "Communicate loudly and constantly.",
      "Win the drill — practice habits become game habits.",
      "Coachability: receive feedback and apply it immediately.",
    ],
  },
  {
    id: "communication",
    icon: "MessageSquare",
    title: "Communication",
    summary: "How we talk on the floor and off it.",
    points: [
      "Early, loud, and continuous talk on defense.",
      "Call out screens, switches, and help in real time.",
      "Encourage teammates — energy is contagious.",
      "Eye contact and active listening in the huddle.",
    ],
  },
  {
    id: "offensive-identity",
    icon: "Zap",
    title: "Offensive Identity",
    summary: "How we want to play with the ball.",
    points: [
      "Play fast, play unselfish, play with pace and space.",
      "Move the ball and move bodies — 0.5 second decisions.",
      "Attack the paint, kick to shooters, crash with purpose.",
      "Great shots over good shots — read the defense.",
    ],
  },
  {
    id: "defensive-identity",
    icon: "Shield",
    title: "Defensive Identity",
    summary: "How we want to play without the ball.",
    points: [
      "Defense travels — it's our identity every night.",
      "Pressure the ball, load to the help, protect the paint.",
      "Contest every shot, finish with a box-out.",
      "Five players connected on a string.",
    ],
  },
  {
    id: "terminology",
    icon: "BookOpen",
    title: "Terminology",
    summary: "A shared language so we play fast and think faster.",
    points: [
      "Common terms for actions, coverages, and sets.",
      "Quick calls that let us communicate without hesitation.",
      "Consistent language from JV to Senior program.",
      "Learn the vocabulary — it's how we play connected.",
    ],
  },
  {
    id: "player-expectations",
    icon: "ClipboardCheck",
    title: "Player Expectations",
    summary: "What every player owes the program.",
    points: [
      "Academics first — eligibility and excellence in the classroom.",
      "Be a great teammate and a great representative of the school.",
      "Take ownership of your development on and off the court.",
      "Compete, communicate, and care — every day.",
    ],
  },
  {
    id: "manager-expectations",
    icon: "ListChecks",
    title: "Manager Expectations",
    summary: "The standard for our team managers and staff.",
    points: [
      "Be early, organized, and reliable.",
      "Own the details — equipment, film, stats, logistics.",
      "Hold the same standard of professionalism as players.",
      "You are an essential part of the team's success.",
    ],
  },
  {
    id: "coaching-standards",
    icon: "Award",
    title: "Coaching Standards",
    summary: "The standard I hold myself and my staff to.",
    points: [
      "Be the most prepared person in the gym.",
      "Coach the person first, the player second.",
      "Teach with clarity, correct with care.",
      "Model the standard — never ask what we won't give.",
    ],
  },
];
